import React, {Component} from 'react'
import {Dropdown, Icon, Label} from "semantic-ui-react";
import _ from "lodash";
import moment from 'moment';
import CdpPayCalendar from '../CdpPayCalendar/CdpPayCalendar';
import "react-datepicker/dist/react-datepicker.css";
import { isBlankNullOrUndefined } from '../../utils/validations';
import {formatCurrency} from "./services";

export default class CdpReportsTableByPractice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            column: null,
            data: props.reportData,
            order: true,
            isPayStubSummary: false,
            docAbbr: null,
            hideColumn:{
                'ABBR' : false,
                'contractType' : false,
                'workTimeType' : false,
                'scheduledDays' : false,
                'workedDays' : false,
                'rtoApproved' : false,
                'ftoApproved' : false,
                'patientVisits' : false,
                'patientVisitsPerDay' : false,
                'rampStartDate' : false,
                'rampEndDate' : false,
                'date' : false,
                'scheduleColumn' : false,
                'care' : false,
                'writeOff' : false,
                'adjustment' : false,
                'careFraction' : false,
                'bCare' : false,
                'financialNotes' : false,
                'procBasedPay' : false,
                'percentageOfBillable' : false,
            }
        }
    }

    handleSort = clickedColumn => () => {
        const { column, data, order } = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                data: _.sortBy(data, [clickedColumn]),
                order: true,
            })

            return
        }

        this.setState({
            data: data.reverse(),
            order: !order ,
        })
    }

    getMonthlyData = (abbr) => {
        this.setState({ docAbbr: null },() => {
            this.setState({isPayStubSummary: true, docAbbr: abbr ? abbr : null});
        });
    }

    onChangeHideColumn = (e, element) => {
        let hideColumn = {...this.state.hideColumn};
        Object.keys(hideColumn).forEach(key=>{
            hideColumn[key]=element.value.includes(key);
        })
        this.setState({hideColumn});
    }

    getColumnOptions=()=>{
        const obj ={
            'ABBR' : 'ABBR',
            'contractType' : 'Contract Type',
            'workTimeType' : 'Work Time Type',
            'scheduledDays' : 'Scheduled Days',
            'workedDays' : 'Worked Days',
            'rtoApproved' : 'RTO Approved',
            'ftoApproved' : 'FTO Approved',
            'patientVisits' : 'Patient Visits',
            'patientVisitsPerDay' : 'Patient Visits Per Day',
            'rampStartDate' : 'Ramp Start Date',
            'rampEndDate' : 'Ramp End Date',
            'date' : 'Date',
            'scheduleColumn' : 'Schedule',
            'care' : 'Care',
            'writeOff' : 'Write Off',
            'adjustment' : 'Adjustment',
            'careFraction' : 'Care Fraction',
            'bCare' : 'bCare',
            'financialNotes' : 'Financial Notes',
            'procBasedPay' : 'Total Pay',
            'percentageOfBillable' : '% of Billable',
        }
        return Object.keys(obj).map((key)=>{return {key,text: obj[key],value: key}})

    }

    getTableRow = (patientVisits, date, startEnd, doctorDayBCare, dayFinNotesTotal,dateAdjustment, dateWriteOff, prodAdjWo, DayProcFee, indexKey, indexKey2, indexKey3) => {
        const { hideColumn } = this.state;
        const scheduleColumn = startEnd.length ? `${moment(parseInt(startEnd[0].start)).utc().format('hh:mm A')} - ${moment(parseInt(startEnd[0].end)).utc().format('hh:mm A')}` : 'Not scheduled'
        return (
            <tr key={"row -level-1" + indexKey + "" + indexKey2 + "" + indexKey3} >
                <td className={"expandedLevelOneBackground"} colSpan={2}> </td>
                {!hideColumn.ABBR && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.contractType && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.workTimeType && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.scheduledDays && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.workedDays && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.rtoApproved && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.ftoApproved && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.patientVisits && <td className={"expandedLevelOneBackground"} > {patientVisits}</td>}
                {!hideColumn.patientVisitsPerDay && <td className={"expandedLevelOneBackground"}> </td>}
                {!hideColumn.rampStartDate && <td className={"expandedLevelOneBackground"}> </td>}{/* Ramp start date */}
                {!hideColumn.rampEndDate && <td className={"expandedLevelOneBackground"}> </td>}{/* Ramp end date */}
                {!hideColumn.date && <td className={"expandedLevelOneBackground"}> {date}</td>}
                {!hideColumn.scheduleColumn && <td className={"expandedLevelOneBackground"}> {scheduleColumn}</td>}
                {!hideColumn.care && <td className={"expandedLevelOneBackground"}> {formatCurrency(DayProcFee)}</td>}
                {!hideColumn.writeOff && <td className={"expandedLevelOneBackground"}> {formatCurrency(dateWriteOff)}</td>}
                {!hideColumn.adjustment && <td className={"expandedLevelOneBackground"}> {formatCurrency(dateAdjustment)}</td>}
                {!hideColumn.careFraction && <td className={"expandedLevelOneBackground"}> {prodAdjWo}%</td>}
                {!hideColumn.bCare && <td className={"expandedLevelOneBackground"} > {formatCurrency(doctorDayBCare)}</td>}
                {!hideColumn.financialNotes && <td className={"expandedLevelOneBackground"} > {formatCurrency(dayFinNotesTotal)}</td>}
            </tr>
        )
    }

    getTableRows  = () => {
        const { column, order, hideColumn} = this.state
        const {
            reportData, getNumberOfWorkedDays, getNumberOfScheduledDays, getRTODetails, getDoctorFullName, calculateBCare,
            getDateAdjustment, getDateWriteOff, filterTableData, filters, scheduleHours
        } = this.props
        let tableRows = []
        const orders = order ? 'asc':'desc';

        let filteredData = filterTableData(reportData)
        let sortedReportData = _.orderBy(filteredData,[column],[orders])

        if(Object.keys(sortedReportData).length) {
            let indexKey = 1;
            let cumulativePatientVisits = 0;
            let cumulativeCare = 0;
            let cumulativeWriteOff  = 0;
            let cumulativeAdjustment = 0;
            let cumulativebCare = 0;
            let cumulativeFinancialNotes = 0;
            let cumulativePay = 0;
            for(let i = 0; i < sortedReportData.length; i++) {
                indexKey++;
                let row = sortedReportData[i];
                const key = row.practice
                let Data = {};
                const practiceName = row.practiceName.toLowerCase();
                let levelOneIcon = 'plus';
                const DoctorRow = Object.keys(row.data);
                for (let index = 0; index < DoctorRow.length; index++) {
                    const ABBR = DoctorRow[index];
                    if(filters.isActive === 'active'){
                        if(row.data[ABBR].isActive === true){
                            Data[ABBR] = row.data[ABBR];
                        }
                    }else if(filters.isActive === 'inActive'){
                        if(row.data[ABBR].isActive === false){
                            Data[ABBR] = row.data[ABBR];
                        }

                    } else{
                        Data = row.data;
                        break;
                        
                    }
                    
                }
                if(isBlankNullOrUndefined(Data)){
                    break;
                }
                row.data = Data;
                row.care = 0;
                row.writeOff = 0;
                row.adjustment = 0;
                row.bCare = 0;
                row.financialNotesTotal = 0;
                row.procBasedPay = 0;

                Object.keys(Data).forEach((ABBR) => {
                    const doctorData = Data[ABBR];
                    row.care += doctorData.price;
                    row.writeOff += doctorData.doctorWriteOff;
                    row.adjustment += doctorData.doctorAdjustment;
                    row.bCare += doctorData.doctorBCare;
                    row.financialNotesTotal += doctorData.financialNotes;
                    row.procBasedPay += doctorData.totalPrice;
                    cumulativePatientVisits += doctorData.patientVisits;
                    cumulativeCare += doctorData.price;
                    cumulativeWriteOff += doctorData.doctorWriteOff;
                    cumulativeAdjustment += doctorData.doctorAdjustment;
                    cumulativebCare += doctorData.doctorBCare;
                    cumulativeFinancialNotes += doctorData.financialNotes;
                    cumulativePay += doctorData.totalPrice;
                });

                row.practiceDoctors = this.props.getPracticeDoctors(Data);

                const percentageOfBillable = row.percentageOfBillable !== null ? row.percentageOfBillable : 0;
                if(this.props.expandableColumn === key){
                    levelOneIcon = 'minus'
                }
                tableRows.push(
                    <tr key={key+''+indexKey}>
                        <td>{<Icon onClick={()=>this.props.expandRow(key)} className={`${levelOneIcon} red`} size='small' />}{(row.practiceName)}</td>
                        <td>{row.practiceDoctors.split(",").map(r=>{
                            if(r.endsWith("#")){
                               return <span className={"text-red"}>{r.split("#").join("")}</span>
                            }
                            return r;
                        })}</td>
                        {!hideColumn.ABBR && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.contractType && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.workTimeType && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.scheduledDays && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.workedDays && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.rtoApproved && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.ftoApproved && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.patientVisits && <td> {row.patientVisits}</td>}
                        {!hideColumn.patientVisitsPerDay && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.rampStartDate && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.rampEndDate && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.date && this.props.expandableRowLevel2 && <td> </td>}
                        {!hideColumn.scheduleColumn && this.props.expandableRowLevel2 && <td> </td>}
                        {!hideColumn.care && <td> {formatCurrency(row.care)}</td>}
                        {!hideColumn.writeOff && <td >{formatCurrency(row.writeOff)}</td>}
                        {!hideColumn.adjustment && <td >{formatCurrency(row.adjustment)}</td>}
                        {!hideColumn.careFraction && this.props.expandableColumn && <td> </td>}
                        {!hideColumn.bCare && <td>{formatCurrency(row.bCare)}</td>}
                        {!hideColumn.financialNotes && <td>{formatCurrency(row.financialNotesTotal)}</td>}
                        {!hideColumn.procBasedPay && <td>{formatCurrency(row.procBasedPay)}</td>}
                        {!hideColumn.percentageOfBillable && <td>{(percentageOfBillable).toFixed(2)}%</td>}
                    </tr>
                );

                if(this.props.expandableColumn === key){
                    const data = row.data
                    if(data && Object.keys(data)){
                        let indexKey2 = 1;
                        Object.keys(data).forEach((ABBR) => {
                            indexKey2++;
                            const doctorData = data[ABBR].data
                            const key = row.practice+ABBR
                            const doctorAdjustment = data[ABBR].doctorAdjustment
                            const doctorWriteOff  = data[ABBR].doctorWriteOff
                            const doctorProcfee = data[ABBR].price
                            const prodAdjWo =  data[ABBR].careAdjWo
                            const doctorBCare = data[ABBR].doctorBCare

                            const doctorName = data[ABBR].doctorNameFromProvider;
                            const {rtoApproved, rtoForced} = getRTODetails(doctorName,practiceName);
                            const workedDays = getNumberOfWorkedDays((ABBR).toLowerCase(),row.practice);
                            const scheduledDays = getNumberOfScheduledDays((ABBR).toLowerCase(),(practiceName).toLowerCase());
                            const payRateOverBase = data[ABBR].payRateOverBase;
                            const doctorProductionPay = data[ABBR].totalPrice;
                            const percentageOfBillable = doctorBCare > 0 ? 
                            ((doctorProductionPay/doctorBCare)*100) : 0;

                            const patientVisits = data[ABBR].patientVisits
                            const patientVisitsPerDay = patientVisits > 0 && workedDays > 0 ?
                             Math.ceil(patientVisits/workedDays) : 0;
                            let level2Icon = 'plus'
                                if(this.props.expandableRowLevel2 === key){
                                    level2Icon = 'minus'
                            }
                             tableRows.push(
                                <tr key = {"row -level-1"+indexKey+""+indexKey2} >
                                    <td  className = {"expandedLevelOneCell"}> </td>
                                    <td className = {"expandedLevelOneCell"}> {<Icon onClick={()=>this.props.expandRowLevelTwo(key)} className={`${level2Icon}  red`} size='small' />}{getDoctorFullName(ABBR)}</td>
                                    {!hideColumn.ABBR && <td className = {"expandedLevelOneCell"}> {ABBR}</td>}
                                    {!hideColumn.contractType && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}>{data[ABBR].contractType}</td>}
                                    {!hideColumn.workTimeType && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}>{data[ABBR].dentistWorkTimeType}</td>}
                                    {!hideColumn.scheduledDays && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}> {scheduledDays}</td>}
                                    {!hideColumn.workedDays && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}> {workedDays}</td>}
                                    {!hideColumn.rtoApproved && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}> {rtoApproved}</td>}
                                    {!hideColumn.ftoApproved && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}> {rtoForced}</td>}
                                    {!hideColumn.patientVisits && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}> {patientVisits}</td>}
                                    {!hideColumn.patientVisitsPerDay && this.props.expandableColumn && <td className = {"expandedLevelOneCell"}> {patientVisitsPerDay}</td>}
                                    {!hideColumn.rampStartDate && <td className = {"expandedLevelOneCell"}>{row.rampStartDate ? moment(row.rampStartDate).format('YYYY-MM-DD') : null}</td>}
                                    {!hideColumn.rampEndDate && <td className = {"expandedLevelOneCell"}>{row.rampEndDate ? moment(row.rampEndDate).format('YYYY-MM-DD') : null}</td>}
                                    {!hideColumn.date && this.props.expandableRowLevel2 && <td className = {"expandedLevelOneCell"} colSpan={1}> </td>}
                                    {!hideColumn.scheduleColumn && this.props.expandableRowLevel2 && <td className = {"expandedLevelOneCell"} colSpan={1}> </td>}
                                    {!hideColumn.care && <td className = {"expandedLevelOneCell"} >{formatCurrency(doctorProcfee)} </td>}
                                    {!hideColumn.writeOff && <td className = {"expandedLevelOneCell"} >{formatCurrency(doctorWriteOff)}</td>}
                                    {!hideColumn.adjustment && <td className = {"expandedLevelOneCell"} >{formatCurrency(doctorAdjustment)}</td>}
                                    {!hideColumn.careFraction && <td className = {"expandedLevelOneCell"} >{prodAdjWo}%</td>}
                                    {!hideColumn.bCare && <td className = {"expandedLevelOneCell"} >{formatCurrency(doctorBCare)}</td>}
                                    {!hideColumn.financialNotes && <td className={"expandedLevelOneCell"}>{formatCurrency(data[ABBR].financialNotes)}</td>}
                                    {!hideColumn.procBasedPay && <td className="expandedLevelOneCell cursorPointer ww" >
                                        <Label className="cursorPointer primaryColor">
                                        <span onClick={() => this.getMonthlyData(ABBR)}>
                                            {formatCurrency(doctorProductionPay)}
                                        </span>
                                        </Label>
                                    </td>}
                                    {!hideColumn.percentageOfBillable && <td className = {"expandedLevelOneCell"} >{percentageOfBillable.toFixed(2)}%</td>}
                                </tr>
                            )
                            if(key === this.props.expandableRowLevel2){
                                    if(doctorData && Object.keys(doctorData)) {
                                        let indexKey3 = 1;
                                        let doctorDates = [];
                                        Object.keys(doctorData).forEach((date,index) => {
                                            indexKey3++
                                            doctorDates.push(date);
                                            
                                            const dayData = doctorData[date].data
                                            const patientVisits = doctorData[date].patientVisits
                                            const DayProcFee = dayData.reduce((total, obj) => obj.Procfee + total,0)
                                            let dateAdjustment = getDateAdjustment(ABBR, row.practice,date)
                                            let dateWriteOff  = getDateWriteOff(ABBR, row.practice,date)
                                            const doctorDayBCare = calculateBCare(DayProcFee,dateAdjustment,dateWriteOff,prodAdjWo);
                                            const startEnd  = scheduleHours[practiceName]? scheduleHours[practiceName].filter(shift => moment(shift.startDate).utc().format('YYYY-MM-DD') === date) : [];
                                            tableRows.push(this.getTableRow(patientVisits, date, startEnd, doctorDayBCare, doctorData[date].financialNotes,dateAdjustment, dateWriteOff, prodAdjWo, DayProcFee, indexKey, indexKey2, indexKey3))
                                        })
                                    }
                            }
                        })
                    }
                }
            }

            const cumulativePercentageOfBillable = cumulativebCare > 0 ? (cumulativePay / cumulativebCare) * 100 : 0;
            tableRows.push(
            <tr className="font-weight-bold" key = {"row-total-level-0"+indexKey}>
                <td></td>
                <td className="font-weight-bold">Total</td>
                {!hideColumn.ABBR && this.props.expandableColumn && <td> </td>}
                {!hideColumn.contractType && this.props.expandableColumn && <td> </td>}
                {!hideColumn.workTimeType && this.props.expandableColumn && <td> </td>}
                {!hideColumn.scheduledDays && this.props.expandableColumn && <td> </td>}
                {!hideColumn.workedDays && this.props.expandableColumn && <td> </td>}
                {!hideColumn.rtoApproved && this.props.expandableColumn && <td> </td>}
                {!hideColumn.ftoApproved && this.props.expandableColumn && <td> </td>}
                {!hideColumn.patientVisits && <td>{cumulativePatientVisits}</td>}
                {!hideColumn.patientVisitsPerDay && this.props.expandableColumn && <td> </td>}
                {!hideColumn.rampStartDate && this.props.expandableColumn && <td> </td>}{/* Ramp start date */}
                {!hideColumn.rampEndDate && this.props.expandableColumn && <td> </td>}{/* Ramp end date */}
                {!hideColumn.date && this.props.expandableRowLevel2 && <td> </td>}
                {!hideColumn.scheduleColumn && this.props.expandableRowLevel2 && <td> </td>}
                {!hideColumn.care && <td>{formatCurrency(cumulativeCare)}</td>}
                {!hideColumn.writeOff && <td>{formatCurrency(cumulativeWriteOff)}</td>}
                {!hideColumn.adjustment && <td>{formatCurrency(cumulativeAdjustment)}</td>}
                {!hideColumn.careFraction && this.props.expandableColumn && <td colSpan={1}> </td>}
                {!hideColumn.bCare && <td>{formatCurrency(cumulativebCare)}</td>}
                {!hideColumn.financialNotes && <td>{formatCurrency(cumulativeFinancialNotes)}</td>}
                {!hideColumn.procBasedPay && <td>{formatCurrency(cumulativePay)}</td>}
                {!hideColumn.percentageOfBillable && <td>{cumulativePercentageOfBillable.toFixed(2)} %</td>}
            </tr>)
            this.props.updateHeaderLabel(tableRows.length); 
        } else {
            tableRows.push(
                <tr key={'no results'}>
                    <td colSpan="4">No Record Found</td>
                </tr>
            )
            this.props.updateHeaderLabel(0); 
        }
        return tableRows;
    }

    onModalClose = (data) => {
        this.setState({isPayStubSummary: data.cdpReportTablePage, docAbbr: data.docAbbr});
    };

    componentWillUnmount = () => {
        this.props.resetFilter();
    }


    render() {
        const {contractNameOptions, dentistOptions, regionListOptions, practiceOptions,udaRoleOptions,brandOptions ,isActiveOptions, onChangeFilter, filters, rampDateOptions} = this.props
        const defaultBrandNames = filters.brandName
        const columnOptions = this.getColumnOptions();
        const { column, order, hideColumn } = this.state;
        const direction = order? 'down': 'up';

        return(
            <div>
                <div>
                    <div className="float-right practiceTop">
                    <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-right'
                            placeholder='Ramp Filter'
                            selection
                            search
                            name="rampDate"
                            options={rampDateOptions}
                            onChange={onChangeFilter}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-right mr10'
                            placeholder='Practice Filter'
                            selection
                            search
                            name="practiceName"
                            options={practiceOptions}
                            onChange={onChangeFilter}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-right'
                            placeholder='UDA Role Filter'
                            selection
                            search
                            multiple={true}
                            name="role"
                            options={udaRoleOptions && udaRoleOptions.filter(opt => opt.value !== null)}
                            onChange={onChangeFilter}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-right mr10'
                            placeholder='Region Filter'
                            selection
                            search
                            name="region"
                            options={regionListOptions}
                            onChange={onChangeFilter}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-right mr10'
                            placeholder='Provider Filter'
                            selection
                            search
                            name="dentist"
                            options={dentistOptions}
                            onChange={onChangeFilter}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-right mr10'
                            placeholder='Contract Type Filter'
                            selection
                            multiple={true}
                            search
                            name="contractType"
                            options={contractNameOptions && contractNameOptions.filter(opt => opt.value !== null)}
                            onChange={onChangeFilter}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-right mr10'
                            placeholder='Provider status'
                            selection
                            search
                            name="isActive"
                            options={isActiveOptions}
                            onChange={onChangeFilter}
                            defaultValue={filters.isActive}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-left mr10'
                            placeholder='Brand Filter'
                            selection
                            multiple
                            search
                            name="brandName"
                            options={brandOptions}
                            onChange={onChangeFilter}
                            defaultValue={defaultBrandNames}
                        />
                        <Dropdown
                            style={{minWidth: '200px'}}
                            className='float-left'
                            placeholder='Hide Column'
                            selection
                            multiple
                            search
                            name="hideColumn"
                            options={columnOptions}
                            onChange={this.onChangeHideColumn}
                        />
                    </div>
                </div>
                <div className="table-responsive tableFixHeadAndFirstTwoColumn">
                    <table className="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th className={`cursorPointer ${column === 'practiceName' ? 'active': ''}`} onClick={this.handleSort('practiceName')}>
                                <div>
                                    Practice
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>
                            <th className={`cursorPointer ${column === 'practiceABBRs' ? 'active': ''}`} onClick={this.handleSort('practiceABBRs')}>
                                <div>
                                    Provider(s)
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>
                            {!hideColumn.ABBR && this.props.expandableColumn && <th className={`cursorPointer ${column === 'practiceDoctors' ? 'active': ''}`} onClick={this.handleSort('practiceDoctors')}>
                                <div>
                                    ABBR
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}{!hideColumn.contractType && this.props.expandableColumn && <th className={`cursorPointer ${column === 'practiceDoctors' ? 'active': ''}`} onClick={this.handleSort('practiceDoctors')}>
                                <div>
                                    Contract Type
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}{!hideColumn.workTimeType && this.props.expandableColumn && <th className={`cursorPointer ${column === 'practiceDoctors' ? 'active': ''}`} onClick={this.handleSort('practiceDoctors')}>
                                <div>
                                    Work Time Type
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.scheduledDays && this.props.expandableColumn && <th>
                                <div className={`cursorPointer ${column === 'scheduledDays' ? 'active': ''}`} onClick={this.handleSort('scheduledDays')}>
                                    Scheduled Days
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.workedDays && this.props.expandableColumn && <th className={`cursorPointer ${column === 'workedDays' ? 'active': ''}`} onClick={this.handleSort('workedDays')}>
                                <div>
                                    Worked Days
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.rtoApproved && this.props.expandableColumn && <th className={`cursorPointer ${column === 'rtoApproved' ? 'active': ''}`} onClick={this.handleSort('rtoApproved')}>
                                <div>
                                    RTO - Approved
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.ftoApproved && this.props.expandableColumn && <th className={`cursorPointer ${column === 'rtoForced' ? 'active': ''}`} onClick={this.handleSort('rtoForced')}>
                                <div>
                                    FTO - Approved
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.patientVisits && <th className={`cursorPointer ${column === 'patientVisits' ? 'active': ''}`} onClick={this.handleSort('patientVisits')}>
                                <div>
                                    Patient Visits
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.patientVisitsPerDay && this.props.expandableColumn && <th className={`cursorPointer ${column === 'PatientVisitsPerDay' ? 'active': ''}`} onClick={this.handleSort('PatientVisitsPerDay')}>
                                <div>
                                    PT Visits/Day
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.rampStartDate && this.props.expandableColumn && <th className={`cursorPointer ${column === 'rampStartDate' ? 'active': ''}`} onClick={this.handleSort('rampStartDate')}>
                                <div>
                                    Ramp Start Date
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.rampEndDate && this.props.expandableColumn && <th className={`cursorPointer ${column === 'rampEndDate' ? 'active': ''}`} onClick={this.handleSort('rampEndDate')}>
                                <div>
                                    Ramp End Date
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>}
                            {!hideColumn.date && this.props.expandableRowLevel2 &&
                            <th className={`cursorPointer ${column === 'care' ? 'active': ''}`} >
                                <div>
                                    Procedure Date
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>

                            </th>
                            }
                            {!hideColumn.scheduleColumn && this.props.expandableRowLevel2 &&
                            <th className={`cursorPointer ${column === 'startEnd' ? 'active': ''}`} >
                                <div>
                                    Start - End
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                             </th>
                            }
                            {!hideColumn.care && <th className={`cursorPointer ${column === 'care' ? 'active': ''}`} onClick={this.handleSort('care')}>
                                <div>
                                    Care
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th >
                            }
                            {!hideColumn.writeOff && <th className={`cursorPointer ${column === 'writeOff' ? 'active': ''}`} onClick={this.handleSort('writeOff')}>
                                <div>
                                    Write Offs
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>
                            }
                            {!hideColumn.adjustment && <th className={`cursorPointer ${column === 'adjustment' ? 'active': ''}`} onClick={this.handleSort('adjustment')}>
                                <div>
                                    Adjustments
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>
                            }
                            {!hideColumn.careFraction && this.props.expandableColumn &&
                            <th className={`cursorPointer ${column === 'careFraction' ? 'active': ''}`} >
                                <div>
                                    Care Fraction
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>
                            }
                            {!hideColumn.bCare && <th className={`cursorPointer ${column === 'bCare' ? 'active': ''}`} onClick={this.handleSort('bCare')}>
                                <div>
                                    bCare
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>
                            }
                            {!hideColumn.financialNotes && <th className={`cursorPointer ${column === 'financialNotesTotal' ? 'active': ''}`} onClick={this.handleSort('financialNotesTotal')}>
                                <div>
                                    Financial Note
                                    <i className={`sort amount ${direction} icon ml-05`}></i>
                                </div>
                            </th>
                            }
                            {!hideColumn.procBasedPay && <th className={`cursorPointer ${column === 'procBasedPay' ? 'active': ''}`} onClick={this.handleSort('procBasedPay')}>
                                <div>
                                    Total Pay
                                    <i className={`sort amount ${direction} icon ml-05`}> </i>
                                </div>
                            </th>
                            }
                            {!hideColumn.percentageOfBillable && <th className={`cursorPointer ${column === 'percentageOfBillable' ? 'active': ''}`} onClick={this.handleSort('percentageOfBillable')}>
                                <div>
                                    % of Billable
                                    <i className={`sort amount ${direction} icon ml-05`}> </i>
                                </div>
                            </th>
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {this.getTableRows()}
                        </tbody>
                    </table>
                </div>
                {this.state.isPayStubSummary ? 
                <CdpPayCalendar 
                    isPayStubSummary={this.state.isPayStubSummary} 
                    docAbbr={this.state.docAbbr}
                    onModalClose={this.onModalClose}
                    cdpReportTablePage={true}
                    {...this.props}
                /> : null}
            </div>

        );
    }
}
